(ns frontend.view.settings2.contact-lists.sub
  (:require
   [re-frame.core :as rf]))

(rf/reg-sub
 ::view-mode
 (fn [db _]
   (get db ::view-mode)))

(rf/reg-sub
 ::edit-mode?
 (fn [db _]
   (get db ::edit-mode?)))

(rf/reg-sub
 ::validation-errors
 (fn [db _]
   (get db ::validation-errors)))

(rf/reg-sub
 ::selected-contact-list
 (fn [db _]
   (get db ::selected-contact-list)))


(rf/reg-sub
 ::delete-confirmation-dialog-open?
 (fn [db _]
   (get db ::delete-confirmation-dialog-open?)))


